'use client'
import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC, useEffect, useState } from 'react'

import { stylePanelSBData } from '@/lib/stylePanel'

import { PhnxVideoslider } from './Videoslider'
import { VideosliderProps } from './Videoslider'

interface VideosliderBlokProps {
  blok: {
    title: VideosliderProps['title']
    description: VideosliderProps['description']
    items: SbBlokData[]
    background?: SbBlokData[]
    colour?: SbBlokData[]
  } & SbBlokData
}

const Videoslider: FC<VideosliderBlokProps> = ({ blok }) => {
  let stylePanel = stylePanelSBData(blok.colour, blok.background, '', '')
  const [items, setItems] = useState<VideosliderProps['items']>([])

  useEffect(() => {
    // we need to loop blok.items and set the items state
    if (blok.items && blok.items.length > 0) {
      const newItems = blok.items.map((item: any) => ({
        title: item.title,
        description: item.description,
        video: [
          {
            url: item.video_id,
            altText: '',
            type: item.video_type,
          },
        ],
      }))
      setItems(newItems)
    }
  }, [blok.items])

  return (
    <div {...storyblokEditable(blok)}>
      <PhnxVideoslider
        title={blok.title}
        description={blok.description}
        items={items}
        textColor={stylePanel.textColor}
        backgroundColor={stylePanel.backgroundColor}
      />
    </div>
  )
}

export default Videoslider
